<template>
  <div class="wrapper">
    <div class="center">
      <h1>404</h1>
      <div class="subtitle">{{ $t('notFound.subtitle') }}</div>
      <p>{{ $t('notFound.description') }}</p>
      <button class="link" @click="back"><span>{{ $t('notFound.goBack') }}</span></button>
      <button class="link"
              v-if="isAuth"
              @click="workflow">
        <span>{{ $t('navigation.dashboard') }}</span>
      </button>
    </div>
  </div>
</template>

<script>
  export default {
    methods: {
      back() {
        this.$router.go(-2)
      },
      workflow() {
        this.$router.push({name: 'dashboard'})
      },
    },
    computed: {
      isAuth() {
        return this.$auth.isLoggedIn()
      }
    }
  }
</script>

<style lang="scss" scoped>
  .wrapper {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #f4f5fa;

    .center {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);

      h1 {
        font-size: 64px;
        font-weight: bold;
      }

      .subtitle {
        margin-bottom: 10px;
      }

      p {
        color: #8a8a8a;
        margin-bottom: 10px;
      }

      .link {
        background: transparent;
        border: 0;
        margin: 0 20px 0 0;
        padding: 0;
        cursor: pointer;
        color: #3498db;

        &:last-child {
          margin-right: 0;
        }

        span {
          padding-bottom: 2px;
          border-bottom: 1px solid #3498db;
        }

        &:hover span {
          border-bottom-color: transparent;
        }
      }
    }
  }
</style>